import { ResponsiveTableRow } from '@fs/zion-ui'
import React from 'react'
import { PersonLink, UserLink } from '../../app/Links'

export default function RestoreRow({ change }) {
  return (
    <ResponsiveTableRow
      name={change.changeId}
      column1={change.operation}
      column2={change.reason}
      column3={change.date}
      column4={<PersonLink personId={change.personId} personName={change.personName} showId />}
      column5=""
      column6={<UserLink userId={change.submitterId} userName={change.submitterName} />}
      column7=""
    />
  )
}
